/* eslint-disable */

<template>
  <div class="pageDiv">
    <v-card>
      <h2>About the Club</h2>
      <v-card-text>
        The Oklahoma Asian Golf Association was created to promote the game of golf for all Oklahoma Asian amateur golfers and to follow the USGA Amateurs rules and regulations. The goal is to promote the enjoyment and challenge of the game of golf, while playing with integrity and honor for all members. All golf activities are for the benefits of its members. Players of all skill levels are encouraged to join and participate.  All tournaments are based on a calculated handicap index to ensure fair and equitable competition among members
        <br><br>
      </v-card-text>
      <v-card-text class="main-card">
        <h2>{{$AuthSvc.getYear()}} Board Members</h2>
        <div class="officer-card" v-for="member in boardMembers" :key="member.position">
          <v-card class="name-card">
              <div class="name-card-img">
                <v-img class="player-img" :src="'/images/players/' + member.photo">
                </v-img>
              </div>
              <div class="name-card-info">
                  <v-card-title>
                      {{member.position}}
                  </v-card-title>
                  <v-card-text>
                      <span class="name-card-txt">{{member.name}}</span>
                      <br>
                      <span class="label">Phone:</span> {{member.phone}}<br>
                      <span class="label">Email:</span> {{member.email}}
                  </v-card-text>
              </div>
          </v-card>
        </div>
      </v-card-text>

      <v-card-text v-if="cupCaptains.length > 0">
        <h2>Cup Captains</h2>
        <div class="officer-card" v-for="member in cupCaptains" :key="member.position">
          <v-card flat class="name-card">
            <div class="name-card-img">
              <v-img class="player-img" :src="'/images/players/' + member.photo">
              </v-img>
            </div>
            <div class="name-card-info">
              <v-card-title>
                {{member.position}}
              </v-card-title>
              <v-card-text>
                <span class="name-card-txt">{{member.name}}</span>
                <br>
                <span class="label">Phone:</span> {{member.phone}}<br>
                <span class="label">Email:</span> {{member.email}}
              </v-card-text>
            </div>
          </v-card>
        </div>
      </v-card-text>


      <v-card-text class="main-card by-laws-card">
        <br><br>
        <h2>Oklahoma Asian Golf Association By-Laws</h2>
        <br>

        <span class="label18">Article I - Name</span> <br>
        The name of this organization is the Oklahoma Asian Golf Association Inc. (OKAGA) (abbreviated for Oklahoma Asian Golf Association and henceforth shall be known as
        <br><br>

        <span class="label18">Article II - Purpose</span> <br>
        The purpose of the organization is to promote golf among the Asian community in the state of Oklahoma including all surrounding cities to the Greater Oklahoma City metropolis area.
        <br><br>
        <span class="label18">Article III - Membership</span> <br>
        Section 1: Membership shall be available to people of all ages, genders, races, and ethnicities. <br><br>
        Section 2: Memberships are individual and non-transferable in the club. <br><br>
        Section 3: Memberships in the club are for 1 calendar year only, with all membership starting on January 1 of the respective membership year and ending on December 31 of the respective membership year. <br><br>

        Section 4: In the event any member of this organization shall commit any act which reflects discredit or disrepute thereon or shall refuse or neglect to comply with the rules and regulations adopted by the Board of Directors, such member shall be subject to suspension or expulsion after ten days written notice and with the right to be heard, by a vote of two-thirds of the Board of Directors at any regular meeting or special meeting called for such purpose.
        The Board of Directors have the right to refuse or revoke membership to anyone who fails to uphold an acceptable code of conduct, rules, and regulations for sake of the integrity and honor of the game of golf and treatment of others. <br><br>

        Section 5: The Board of Directors shall establish all membership fees and dues from time to time in such amounts as they deem to be adequate to operate and maintain the Club. Members shall be liable for their membership dues. <br><br>

        Section 6: The Oklahoma Asian Golf Association name and all intellectual property, including but not limited to registered trademarks, patents, and/or trade secrets, are owned by Oklahoma Asian Golf Association Inc. <br><br>

        Section 7: Indemnification and Hold Harmless: Any Member, Guest or other person who, in any manner, makes use of or accepts the use of any web application, software, apparatus, appliance, facility, privilege or service whatsoever owned, leased, licensed to, or operated by the OKAGA or by any Host Facility, shall do so at his or her own risk. Members and their guests shall hold the OKAGA, any manager or operator of the Host Facility, their affiliates, their successors and assigns and their respective shareholders, partners, directors, officers, members, employees, representatives, and agents (collectively, the “Indemnified Parties”) harmless from any and all loss, cost, claim of injury, damage or liability sustained or incurred by him or her, resulting from the participation in OKAGA event or the use of Host Facility’s property, arising out of or incident to membership in the OKAGA and/or from any act or omission of any of the Indemnified Parties, unless caused by the gross negligence or willful misconduct of any of the Indemnified Parties. Any Member shall have, shall owe and shall observe the same obligation to the Indemnified Parties hereunder in respect to any such loss, cost, claim, injury, damage or liability sustained or incurred by any guest or family member guest. <br><br>

        Section 8 : Assumption of Risks: I am aware that participating in the activities and sports, without limitation, offered by or associated with OKAGA, exposes me to many inherent risks, dangers and hazards. By engaging in any activities offered by or associated with OKAGA, I freely accept and fully assume all inherent risks, dangers and hazards and the possibility of personal injury, death, property damage or loss resulting there from. <br><br>

        <span class="label18">RELEASE OF LIABILITY WAIVER OF CLAIMS & INDEMNITY AGREEMENT:</span> <br> <br>


        In consideration of OKAGA permitting me to participate in its activities and sports, permitting me to the use of its equipment and permitting me the use of its facilities, I hereby agree as follows: <br><br>

        TO WAIVE ANY AND ALL CLAIMS that I have or may in the future have against OKAGA, and its directors, officers, employees, agents, representatives, assigns and successors. <br><br>

        TO RELEASE OKAGA, and its directors, officers, employees, agents, representatives, assigns and successors from any and all liability for any loss, damage, injury or expense that I may suffer or that my next of kin may suffer, as a result of my participation in activities and sports offered by OKAGA, due to any cause whatsoever INCLUDING NEGLIGENCE, BREACH OF CONTRACT, BREACH OF STATUTORY DUTY OF CARE, AND/OR BREACH OF THE OCCUPIER'S LIABILITY ACT, R.S.A. 2000, C. O-4, ON THE PART OF OKAGA and its directors, officers, employees, agents, representatives, assigns and successors. <br><br>

        TO HOLD HARMLESS AND INDEMNIFY OKAGA, and directors, officers, employees, agents, representatives, assigns and successors from any and all liability for any property damage or personal injury to any third party, resulting from my activities and my participation in the activities offered by or associated with OKAGA. That this Agreement shall be effecting and binding upon any heirs, next of kin, executors, administrators and assigns in the event of my death. <br><br>

        I understand that if it is reported by the golf course or an opponent, that I have behaved in an unsporting manner or have not played by the rules, that I could be suspended or ejected from the league, with no refund. <br><br>

        BY PARTICIPATING IN A OKAGA EVENT, I ACCEPT THE ABOVE STATED TERMS
        Section 9: Membership, or registration as a guest for entry into any OKAGA event, includes an express waiver and consent to the use of each Member’s and/or competitor’s name, image and/or likeness by Oklahoma Asian Golf Association Inc., it’s subsidiaries and/or assigns, for purposes of promoting, marketing, reporting, or otherwise advertising the OKAGA mission, its events, chapters, website, etc. Said name, image, likeness may be used in all forms of media, including but not limited to the club’s website, social media channels, digital marketing, print marketing materials, etc. By joining the OKAGA or registering for any OKAGA event, each player expressly waives any right to compensation or control of the use of their name, image, or likeness by OKAGA Inc., its subsidiaries or assigns. <br><br>

        Section 8: OKAGA financial records may be requested by members by contacting the Treasurer. <br><br>

        Section 9: Articles of Dissolution: If the Board of Directors ever vote to dissolve the organization, the Board of Directors must reach a consensus and take an official corporate action (a vote that is documented in minutes of the meeting) to affirm that dissolution of the OKAGA. The Board of Directors must vote to approve a “plan of dissolution”. A (SOS Form 0080, Schedule N (Form 1120, and IRS Form 990) must be filled out and turned in to the Oklahoma Secretary of State and IRS, by the Board of Directors and a vote must be held with a documented plan written on how to distribute the clubs remaining funds. U.S. Federal law requires a tax-exempt charitable nonprofit that is dissolved to distribute its remaining assets ONLY to another tax-exempt organization or to the federal government or a state or local government for public purpose. An inventory of assets will be created to manage this part of the dissolution process. <br><br>

        Section 10: Conflict of Interest: If a Board of Directors member has a potential conflict of interest with an organization or entity that the club is considering a financial relationship or conducting business, that Board member is excused from the room, discussion, and vote about whether to work with that broker. <br><br>

        Board of Directors will also refrain from serving in two organizations in the same field or they will be relieved of duties from one of the two organizations. Board of Directors accepting office with the OKAGA, are agreeing to and declaring they have no conflict of financial interests or affiliations, etc. Board of Directors also agree to obtaining competitive written bids to ensure that prices and products are comparable. <br><br>

        Board of Directors will sign and date the following policy to be documented and kept in official OKAGA records until termination or term expiration: <br><br>

        The standard of behavior of the Oklahoma Asian Golf Association is that all staff, volunteers, and board members scrupulously avoid conflicts of interest between the interests of the OKAGA on one hand, and personal, professional, and business interests on the other. This includes avoiding potential and actual conflicts of interest, as well as perceptions of conflicts of interest. <br><br>

        I understand that the purposes of this policy are to protect the integrity of the OKAGA decision-making process, to enable our constituencies to have confidence in our integrity, and to protect the integrity and reputations of volunteers, staff, and board members. This written disclosure will be kept on file. <br><br>

        In the course of meetings or activities, I will disclose any interests in a transaction or decision where I (including my business or other nonprofit affiliations), my family, and/or my significant other, employer, or close associates will receive a benefit or gain. After disclosure, I understand that I will be asked to leave the room for the discussion and will not be permitted to vote on the question. <br><br>

        I understand that this policy is meant to supplement good judgment, and I will respect its spirit as well as its wording. Signed: Date: <br><br>


        <span class="label18">Article IV – Board of Directors</span> <br>
        Section 1:
        The Board of Directors will run the association for a period of two years (each year of tenure begins, January 1 of the particular calendar year and ending on December 31 of the same calendar year). Additional years of service are strictly voluntary, all Board of Directors positions are limited to 3 terms of (2 years each term). The Board of Directors will delegate their duties among themselves and call for meetings when deemed necessary. <br><br>

        In the instance, when a Board of Director’s cannot finish their term of duty or are deemed by the Board of Directors to not be fulfilling their duties to the club, the remaining Board of Directors will vote to name a replacement for the position among the club members, if that member so chooses to accept. Board of Directors positions must only be held by an active OKAGA member. <br><br>

        Section 2:
        Election Process: At the end of each Board of Directors term (2 years), the Board of Directors are responsible for conducting the election process. At least, one prior golf season membership status is required, for an individual (member of OKAGA) seeking nomination and office and 3 term limits for existing Board of Directors applies. <br><br>

        The Board of Directors shall consist of the following positions and their duties shall be such as their title would indicate, or such as may be assigned to them respectively by the President: <br><br>

        <span class="label18">President:</span> <br>
        <ul>
          <li>Communicate the state of the club, special notices, and any inter-club announcements via email and social media postings.</li>
          <li>Responsible for reviewing all club inquiries including feedback and complaints, including internal and external affairs.</li>
          <li>Oversee tournament and year end banquet activities.</li>
        </ul>
        <br>

        <span class="label18">Vice President:</span> <br>
        <ul>
          <li>Shall keep and record the Board of Directors meetings and resolutions and assist the President with all the administrative matters and conduct the Board of Directors affairs in their absence.</li>
          <li>Handle club voting app or program on club matters.</li>
          <li>Assist other Board of Directors with respective job duties.</li>
        </ul>
        <br>

        <span class="label18">Treasurer:</span> <br>
        <ul>
          <li>Document financial transactions for the club.</li>
          <li>Collect green fee prior and or during OKAGA tournaments.</li>
          <li>Provide financial reporting and annual budgeting.</li>
        </ul>
        <br>

        <span class="label18">Handicap Director:</span> <br>
        <ul>
          <li>Maintain handicap for all members.</li>
          <li>Calculate adjusted handicap after each tournament.</li>
          <li>Update members’ handicap on the website.</li>
        </ul>
        <br>

        <span class="label18">Tournament Director:</span> <br>
        <ul>
          <li>Select tournament venues and negotiate contracts on behalf of OKAGA.</li>
          <li>Provide and announce USGA and local course rulings prior to each event.</li>
          <li>Post upcoming tournament signup and information.</li>
          <li>Provide pairing information prior to the event.</li>
          <li>Collect score cards and or electronic scoring at each tournament to determine and announce Gross and
            Net Winner.</li>
        </ul>
        <br>

        <span class="label18">Sponsorship Director:</span> <br>
        <ul>
          <li>Actively pursue businesses, organizations, and persons to raise funding for the function and operation of the association.</li>
          <li>Advertise and promote through social media, word of mouth, and promotion at tournaments of the sponsorship donors.</li>
        </ul>
        <br>

        <span class="label18">Technology Director:</span> <br>
        <ul>
          <li>Create, update and maintain social media and technologies related to OKAGA tournaments, operations, and functions.</li>
          <li>Coordinate/hire volunteer or paid photographers for OKAGA tournaments and functions.</li>
          <li>Upload photographs and video from OKAGA tournaments and functions.</li>
        </ul>
        <br>

        <span class="label18">Article V - Amendments to By-Laws</span> <br>

        The Board of Directors shall have the power to repeal or amend any of these by-laws provided that such action shall not be effective until approved by a majority vote of all the present residing Board of Directors of the OKAGA at a meeting held in accordance with the provisions contained herein, at any such time. Notice of changes will be announced to the club members.
        <br><br>

        <span class="label18">Article VII - OKAGA vs. “X” Ryder Cup</span> <br>
        <ul>
          <li>There will be two 24 player teams (A/B) for each respective club (OKAGA 48 / “X” Club 48)</li>
          <li>Members make each respective team based on points acquired through regular season
            tournament events</li>
          <li>The top 24 players in the Ryder Cup standings will make up the A team</li>
          <li>The next top 22 players (25-46) in the Ryder Cup standings will make up the B team</li>
          <li>OKAGA Ryder Cup Team Captain and Assistant Captain will make 2 final “captain’s picks”
            to fill the remaining 2 roster spots</li>
          <li>If a qualifying player declines to play in the Ryder Cup, the player directly below them in
            the points standings, then becomes eligible and so forth. Player(s) that are unable to
            attend the Ryder Cup, that player must give the Ryder Cup Captain 2 weeks notice prior to
            the event.</li>
        </ul>
        <br>

        <span class="label16">Ryder Cup Qualifying rules:</span> <br>
        <ul>
          <li>All OKAGA members who play a minimum of 3 OKAGA tournaments are qualified to
            compete for the Ryder Cup, and must play from the A, B flight tee box.</li>
          <li>Ryder Cup points are awarded to members based on individual GROSS scoring at all the
            official OKAGA tournaments. Ryder Cup Points are percentage based.</li>
          <li>
            Tie breaker (in the event of a tie for the last spot):
            <ul>
              <li>A. First tie breaker will be based on the low score of the Club Championship tournament.</li>
              <li>B. Second tie breaker will be based on the score of the handicap holes of the Club Championship tournament.</li>
              <li>C. If one player does not participate in the Club Championship tournament, the participating player wins by default.</li>
              <li>D. If both players did not participate in the Club Championship tournament, tie breaker will be the previous tournament and so on.</li>
            </ul>
          </li>
        </ul>
        <br>

        <span class="label18">Article VII - Tournament Rules</span> <br>
        <ul>
          <li>Local and USGA Rules of Golf govern all play (Board of Directors can modify rules according to OKAGA Tournament Rules sheets for each respective tournament)</li>
          <li>OKAGA Tournament Rules sheet will be provided to members prior to start of each tournament and shall be adjusted for each tournament venue and conditions</li>
          <li>Double Par max score per hole (Par 3: max 6 strokes, Par 4, 5: max 8, 10 strokes)</li>
          <li>Each flight’s tee box will be assigned by the Board of Directors based on course
            difficulty/skill level/hdcp, etc.</li>
          <li>Regular season events are individual stroke play (unless specified by Board of Directors)</li>
          <li>Target maximum yardage per course 6500 - 6700 yds (can vary based on course, subject
            to Board of Directors review)</li>
          <li><b>Tiebreaks:</b> in the event any players tie for gross or net event winner, the player with the
            lowest score on the #1 handicap hole of the tournament course, shall be declared the winner, in the event the players remain tied, the scores of the next respective handicap hole will continue until the tie is broken.</li>
          <li><b>Dress Code:</b> Members and Guests are expected to dress in a manner to present a positive public image of the OKAGA with a constant effort to positively reflect the OKAGA in all respects both on and off the golf course at any official OKAGA sanctioned event. Members are expected to dress appropriately for golf while on the golf course. Collared shirts, including blade or mock collars, are required. No jeans, denim or cutoff shorts of any kind will be permitted. Any printed language, slogans, or logos should reflect positively on the OKAGA and its members. Host venue dress code rules may go above and beyond, but no less than, OKAGA dress code policy and all members shall adhere to their respective rules.</li>
          <li>If a member or guest shall withdraw or no-show for any tournament, that member or guest will forfeit their entry fee and repeated actions may lead to suspension from future events based on Board of Directors review.</li>
          <li><b>Spectators:</b> Spectators are welcome at each tournament, noting that each course may have different policies that we abide by as guests of the host facility. Spectators are the responsibility of the associated player who is solely responsible for their proper golf etiquette and general decorum. If any issue(s) arise with their behavior or lack of proper golf etiquette, they will be asked to leave the premises. Golf carts are limited at each event to two carts per group and players always have priority use of a golf cart. Spectators should anticipate and expect to walk the course and stay a reasonable distance away from play as not to be a distraction. (i.e. walking on green, etc.)
            <b>Spectators are under no circumstances allowed to give advice to the player. In the case where this happens, the player will be disqualified.</b> If spectator carts are available, spectators are responsible for any fees incurred for the rental of a spectator cart.</li>
          <li><b>Guests:</b> will not be eligible to win Gross or Net prizes in any respective flight, however members are encouraged to invite and host guests at OKAGA events.</li>
          <li><b>Caddies:</b> No personal caddies are allowed at OKAGA events. Caddies will only be allowed at specific golf courses where caddies are available to the entire field. Caddie availability will be provided (cost, etc.) prior to the competition.</li>
          <li><b>Inclement Weather Policy:</b> All questions as to whether a OKAGA event will be played, delayed or cancelled, should be directed to the Board of Directors. Do not rely upon communication from the Host Facility staff regarding weather-related decisions. The Board of Directors and the Host Facility staff will confer to reach a decision regarding beginning, delaying, or stopping play. That decision will be relayed to competitors via the announcement by mouth at tournament site, email and/or text. Members should not assume that because it is raining or storming at their home that it is doing so at the Host Facility. If the Host Facility permits play, and the Board of Directors determines that it is safe, play will go on.</li>
        </ul>
        <br>

        <span class="label18">Weather-related conditions may delay or suspend play such as:</span> <br>
        <ul>
          <li>Lightning</li>
          <li>Weather Warnings</li>
          <li>Course being deemed unplayable as determined by host facility</li>
        </ul>
        <br>


        All practice facilities are closed during a suspension of play. Violation of this will result in immediate disqualification and potential additional disciplinary action from the OKAGA.
        <br><br>
        If there is a weather delay or suspension of play, every effort will be made by the Tournament Committee to complete the entire event. If weather causes a delay, all players should remain on property and await official announcements from the Tournament Committee. The Tour will communicate by either live announcement, text, or email whether and when play will resume.
        <br><br>
        As a last option, if a weather delay prevents a tournament from finishing, the following may result in an official tournament:
        <br><br>

        ● 18-hole events may be shortened to 9-holes or 9-holes plus the greatest number of common holes completed. If this isn’t possible, it may be rescheduled.
        <br><br>

        ● 36-hole events may become official and be shortened to an 18-hole tournament or 18-holes plus the most number of common holes completed.
        <br><br>

        While the OKAGA will do everything possible to complete an official and full event, there will be no refunds should inclement weather cause an event to be shortened unless the Host Facility provides a refund to the OKAGA.
        <br><br>

        - <b>Exceptional Round Promotion:</b> if a member shoots a tournament round score that is 6 strokes or more below their respective handicap at that time, the Board of Directors reserves the right to re-classify the member into the next flight effective immediately, upon Board of Directors review.
        <br><br>

        - <b>Flight Changes:</b> relegation or promotion requests will be considered by the Handicap Director and Board of Directors upon member request. All requests must be submitted by the member at least 7 days prior to a tournament. The Board of Directors and Handicap Director will communicate their decision upon review.
        <br><br>

        - <b>Establishing Handicap Index:</b> New members to the club that do not have an established GHIN handicap index with at least 10 scores recorded in the past calendar year, shall meet with the President and or Handicap Director to discuss established handicap index for OKAGA tournament play. The Board of Directors will then discuss and establish the new members starting handicap index based on review. *See USGA Rules 5.2 Calculation of a Handicap Index for guidelines.
        <br><br>

        - <b>OKAGA Handicap Rules:</b><br><br>

        - OKAGA tournament handicaps are maintained in accordance with the rules of the official<br><br>

        USGA Handicap System and are monitored regularly by the Board of Directors and the
        Handicap Director.<br><br>

        - Accordingly, under USGA Rules, it is the responsibility of the player to post his/her scores
        to determine an accurate & current handicap.<br><br>

        - Upon completion of a tournament played, each player is required to post/report a valid
        score to the club. Scores are collected by the Handicap Director during the active golf
        season.<br><br>

        - Members with an established current OKAGA handicap are eligible to participate in
        competitive club events including all tournaments and win prizes. A current handicap is defined as a score posted during the active golf season – with a minimum of two 18-hole scores required. The end of the season handicap will be considered a valid handicap to start the following year, until valid scores are posted for the new season.<br><br>

        - Regular random checks will be made by the Handicap Director and the Board of Directors to assure that players are signing in and posting/reporting scores. If it is discovered that a player fails to turn in his/her score after a tournament, or refuses to post a score,a par score will be given to the player and the Board of Directors will be notified for possible disciplinary action up to and including disqualification.<br><br>

        - The Board of Directors has the right to adjust handicaps, if necessary, in consultation with the Handicap Director. Handicaps and the enforcement of their accuracy fall under the authority of the Board of Directors/Handicap Director.<br><br>

        - For a tournament played, it is the responsibility of the Handicap Director to certify the accuracy & legitimacy of any player’s handicap. This process has been ongoing and will assure the accuracy and current status of each handicap/flight.<br><br>

        - It should be noted that these existing “OKAGA Handicap Rules” are being implemented to assure legitimate and accurate handicaps for all play at the club and to promote the honesty & integrity of golf among the playing members at OKAGA as directed by our By-Laws, and subject to revision upon Board of Directors review at any time. In that spirit, members are asked to comply with these directives.<br><br>


        <span class="label18">Flight Handicaps are as follows:</span> <br>
        - A Flight: ≤0 - 7.99 <br>
        - B Flight: 8 - 15.99 <br>
        - C Flight:16 - 30+ <br>

      </v-card-text>

    </v-card>
  </div>
</template>


<script>
  export default {
    data() {
      return {
        boardMembers: [
            {
              position:  'President',
              name:      'Robert Gay',
              phone:     '(405) 641-7051',
              email:     'PresidentOKAGA@gmail.com',
              photo:     'Robert-Gay.png'
            },
            {
              position:  'Vice President',
              name:      'Chuck Truong',
              phone:     '(405) 204-3795',
              email:     'yuckie4u@yahoo.com@gmail.com',
              photo:     'Chuck-Truong.png'
            },
            {
              position:  'Treasurer',
              name:      'Deans Le',
              phone:     '(405) 201-1250',
              email:     'DeansOKAGA@gmail.com',
              photo:     'Deans-Le.png'
            },
            {
              position:  'Sponsorship Director',
              name:      'Hanson Nguyen',
              phone:     '(405) 246-5360',
              email:     'HansonT2005@gmail.com@gmail.com',
              photo:     'Hanson-Nguyen.png'
            },
            {
              position:  'Handicap',
              name:      'Drew Nguyen',
              phone:     '(405) 887-6039',
              email:     'Andrew.OKAGA@gmail.com',
              photo:     'Drew-Nguyen.png'
            },

          ],
          cupCaptains: [                   
          ]
      }
    }
  }
</script>

<style scoped>
  .main-card {
    padding-top: 30px;
    margin-top: 10px !important;
  }

  .officer-card {
    display: inline-block;
    width: 95% !important;
    margin: 10px;
    float: left;
  }

  .player-img {
      border-radius: 7px;
      height: 170px;
  }

  .name-card {
    width: 98% !important;
    background-color: #e6f2ea !important;
    padding: 10px !important;
    display: flex;
  }

  .name-card-img {
    display: inline-block;
    vertical-align: top;
    border-radius: 5px;
    width: 25%;
    height: 175px;
    float: left;
  }

  .name-card-info {
    display: inline-block;
    vertical-align: top;
    width: 73%;
    margin-left: 20px;
    height: 175px;
    float: left;
  }

  .name-card-txt {
    font-size: 16px;
    font-weight: bold;
    color: darkgreen;
  }

  .article {
    font-size: 1.2em;
    padding: 25px 0 7px 0 !important;
  }

  .article-text {
    margin: 0 0 0 10px !important;
  }

  .section {
    font-size: 1.1em;
    margin: 10px 0 0 10px !important;
    padding-bottom: 0  !important;
  }

  .section-text {
    margin: 0 0 0 20px !important;
  }

 .tcard {
    font-weight: bold;
    font-size: 1em;
    padding: 10px 0 0 0 !important;
  }

 .ulcard {
    paddingt-top: 0 !important;
    margin-left: 25px !important;
  }

  ul {
    list-style-type: square;
    padding-top: 0 !important;
  }

  li {
    margin-left: 20px;
  }

  th, td {
    display: inline-block;
    align-text: left !important;
  }

  .by-laws-card {
    font-size: 14px;
    font-family: sans-serif, Arial !important;
  }

  @media (min-width: 768px) {
    .officer-card {
      width: 460px !important;
      height: 190px !important;
    }
  }
</style>